import { createI18n } from "vue-i18n";
import { defaultLocale, fallbackLocale, sharedMessages } from "@ocm/services/services.i18n";

import de from "./de.json";
import en from "./en.json";

type MessageSchema = typeof de;

const i18n = createI18n<[MessageSchema], "de" | "en">({
	locale: defaultLocale,
	fallbackLocale,
	messages: {
		de: { ...de, ...sharedMessages.de },
		en: { ...en, ...sharedMessages.en },
	},
	legacy: false,
});

export default i18n;
